import React from 'react';
import styled from '@emotion/styled/macro';
import vars from '@variables';
import {
  YouTubeEmbedAtom,
  SimplecastEmbedAtom,
} from '@atoms/media-atoms/media-atoms';
import { defineResponsiveGridColumns } from '@utils/utils';
import { MediaBlockProps } from './media-block.types';

export const RichTextEntryMediaBlockContainer = styled.div``;

const MediaBlock: React.FC<MediaBlockProps> = ({
  anchorId,
  mediaSrc = '',
  className,
}) => {
  let content;
  if (mediaSrc && mediaSrc.length > 0) {
    if (mediaSrc.includes('youtube') || mediaSrc.includes('youtu.be')) {
      content = (
        <div className="youtube-container">
          <YouTubeEmbedAtom className={className} src={mediaSrc} />
        </div>
      );
    }

    if (mediaSrc.includes('simplecast'))
      content = (
        <div className="simplecast-container">
          <SimplecastEmbedAtom className={className} src={mediaSrc} />
        </div>
      );

    if (content) {
      return (
        <div id={anchorId} className={className} data-testid="media-block">
          {content}
        </div>
      );
    } else {
      console.error(`Media Block called with invalid source: ${mediaSrc}`);
      return null;
    }
  } else {
    console.error(`Media Block called without a media source`);
    return null;
  }
};

// === MediaBlock CSS ===
const StyledMediaBlock = styled(MediaBlock)`
  display: grid;
  column-gap: ${vars.mobileColumnPercentageGap};
  grid-template-columns: ${defineResponsiveGridColumns(4)};

  @media screen and (min-width: ${vars.breakPointTablet}) {
    column-gap: ${vars.standardColumnPercentageGap};
    grid-template-columns: ${defineResponsiveGridColumns(8)};
  }

  @media screen and (min-width: ${vars.breakPointSmallDesktop}) {
    column-gap: ${vars.standardColumnPercentageGap};
    grid-template-columns: ${defineResponsiveGridColumns(12)};
  }

  margin-top: ${({ anchorId }) => (anchorId ? vars.spacingL : 'auto')};

  .youtube-container,
  .simplecast-container {
    margin: ${vars.spacingM} 0;

    @media only screen and (min-width: ${vars.breakPointTablet}) {
      margin: ${vars.spacingXl} 0;
    }
  }

  .youtube-container,
  .simplecast-container {
    grid-column: col1-start / col4-end;

    @media screen and (min-width: ${vars.breakPointTablet}) {
      grid-column: col2-start / col7-end;
    }

    @media screen and (min-width: ${vars.breakPointSmallDesktop}) {
      grid-column: col2-start / col11-end;
    }
  }
`;

export default StyledMediaBlock;
